
import { Component, Vue } from 'vue-property-decorator'
import GoodsResultCard from '@/views/goodsManage/mall/shop/template/GoodsResultCard.vue'
import { newArrivalList, ShopGoodsListDto } from '@/api/shoppingMall'
import { Getter } from 'vuex-class'

@Component({
  name: 'NewArrivals',
  components: {GoodsResultCard}
})
export default class NewArrivals extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string

  sortValue = ''
  sortOption = [
    {text: '默认排序', value: ''},
    {text: '按价格升序', value: '1-Up'},
    {text: '按价格降序', value: '1-Down'},
    {text: '按销量降序', value: '2-Down'},
    {text: '按商品编码升序', value: '3-Up'},
    {text: '按商品编码降序', value: '3-Down'},
  ]
  // 排序字段 价格：1，销量：2，编码：3
  orderField = ''
  // 排序类型 Up:升序，Down: 降序
  orderType = ''
  params = {
    pageSize: 10,
    pageIndex: 1
  }
  saleList: ShopGoodsListDto[] = []
  refreshing = false
  loading = false
  finished = false

  created () {
    this.getList()
  }

  getList () {
    const param = {
      shopId: this.providerId,
      customerId: this.companyId,
      orderField: this.orderField,
      orderType: this.orderType
    }
    newArrivalList(Object.assign(this.params, param)).then((res) => {
      this.refreshing = false
      this.saleList = res.data.records || []
      if (this.saleList.length >= res.data.totalRecords) {
        this.finished = true
      } else {
        this.finished = false
      }
    }).catch(() => {
      this.refreshing = false
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }

  /**
   * 上拉加载更多
   * */
  onLoad () {
    this.params.pageIndex++
    this.loading = true
    const param = {
      shopId: this.providerId,
      customerId: this.companyId,
      orderField: this.orderField,
      orderType: this.orderType
    }
    newArrivalList(Object.assign(this.params, param)).then((res) => {
      this.saleList = this.saleList.concat(res.data.records)
      this.loading = false
      if (this.saleList.length >= res.data.totalRecords) {
        this.finished = true
      }
    }).catch(() => { })
  }

  reloadList () {
    this.params.pageIndex = 1
    this.getList()
  }

  changeSortValue (val: string) {
    if (val === '') {
      this.orderField = ''
      this.orderType = ''
    } else {
      const typeArr = val.split('-')
      this.orderField = typeArr[0]
      this.orderType = typeArr[1]
    }
    this.getList()
  }

  toBuyCar () {
    this.$router.push('/buyCar')
  }

  goBack () {
    this.$router.back()
  }

  /**
   * 直接跳转回首页
   */
  goHome () {
    this.$goHomeBack()
  }
}
